import { gatewayClient, createService } from './connectors/httpClient';

const httpClient = gatewayClient('/weadapt-users/bynder/groups');

const groupsService = createService(httpClient, (client) => ({
    getGroups() {
        return client.get('');
    },
}));

export default groupsService;
